import { Hash, MapPin, User } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { IdentityDetail } from '@/features/identities/types'
import { EditableField } from './EditableField'

/** Additional inline-editable personal data in the profile tab. */
export function IdentityProfileFields({
  identity,
  onUpdateField,
}: {
  identity: IdentityDetail
  onUpdateField: (field: string, next: string) => Promise<void>
}) {
  const { t } = useTranslation()
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('identity.detail.sections.personalDetails')}</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
        <EditableField
          label={t('identity.detail.fields.personalNumber')}
          icon={Hash}
          value={identity.personalNumber}
          onSave={next => onUpdateField('personalNumber', next)}
          monospace
        />
        <EditableField
          label={t('identity.detail.fields.placeOfBirth')}
          icon={MapPin}
          value={identity.placeOfBirth}
          onSave={next => onUpdateField('placeOfBirth', next)}
        />
        <EditableField
          label={t('identity.detail.fields.address')}
          icon={MapPin}
          value={identity.address}
          onSave={next => onUpdateField('address', next)}
        />
        <EditableField
          label={t('identity.detail.fields.maidenName')}
          icon={User}
          value={identity.maidenName}
          onSave={next => onUpdateField('maidenName', next)}
        />
      </CardContent>
    </Card>
  )
}
